import Vue        from 'vue'
import VueRouter  from 'vue-router'
import Login      from '../views/Login.vue'
import api        from '@/api.js' 

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  { 
    path: '/dashboard', 
    name: 'dashboard', 
    component: () => import('../views/dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path : "/dashboard/:id",
    name : "dashboards",
    props : true,
    // alias : ["/:id"],
    component: () => import('../views/dashboard.vue'),
  },
  // { path: '/settings', name: 'settings', component: () => import('../views/settings.vue')},
  { 
    path  : '/recover_psw', 
    name  : 'recover_psw', 
    props : true,  
    component : () => import('../views/recover_psw.vue')
  },
  { 
    path: '/security_psw', 
    name:'security_psw', component :
    () => import('../views/security_psw.vue')
  },
  { 
    path: '/user', 
    name: 'user', 
    component: () => import('../views/user.vue')
  },
  { 
    path: '/profile', 
    name: 'profile', 
    component: () => import('../views/Profile.vue')
  },
  // { path: '/host_configuration', name:'host_configuration', props:true, component: () => import('../components/lpr/host.vue')},
  // { path: '/reports', name: 'reports', component: () => import('../views/reports.vue') }, // /views/reports.vue
  { 
    path: '/parameters', 
    name: 'parameters', 
    component:() => import('../views/general_parameters.vue')
  }, 
  { 
    path: '/alert_sounds_settings', 
    name: 'alert_sounds_settings', 
    component:() => import('../views/alert_sounds_settings.vue')
  },
  { 
    path: '/tester', 
    name: 'tester', 
    component: () => import('../components/tester/tester.vue')
  },
    // Device
  { 
    path: '/device', 
    name: 'device', 
    component: () => import('../views/add_device.vue') 
  },
  { 
    path: '/settings', 
    name: 'settings', 
    component: () => import('../views/general_parameters.vue')
  },
  { 
    path: '/new_device', 
    name: 'new_device', 
    component: () => import('../components/stream/new_device.vue') 
  },
  { 
    path: '/new_peripheral', 
    name: 'new_peripheral', 
    component: () => import('../components/peripherals/peripherals.vue') 
  },
  {
    path: '/new_access_control',
    name: 'new_access_control',
    component: () => import('../components/access-control/access_control_device.vue')
  },
  {
    path: '/access_control_events',
    name: 'access_control_events',
    component: () => import('../components/access-control/access_control_events.vue')
  },
  
  { 
    path: '/setting_device', 
    name: 'setting_device', 
    component: () => import('../components/stream/setting_device.vue') 
  },
    //view Face
  { 
    path: '/setting_analytic', 
    name: 'setting_analytic', 
    component: () => import('../components/analytics/setting_analytic.vue') 
  },
  { 
    path: '/face', 
    name: 'face', 
    component: () => import('../views/face.vue')
  }, 
  { 
    path: '/trained', 
    name: 'trained', 
    component: () => import('../components/face/trained.vue')
  }, 
  {
    path: '/list_face',
    name: 'list_face',
    component: () => import('../components/lists/listing_details.vue') 
  },
  
  { 
    path: '/reports_face', 
    name: 'reports_face', 
    component: () => import('../components/reports/single_reports.vue') 
  },
  { 
    path: '/search_by_video_face', 
    name: 'search_by_video_face', 
    component: () => import('../views/SearchByVideoFaceView.vue') 
  },
    // view Streaming
  { 
    path: '/streaming', 
    name: 'streaming', 
    component: () => import('../views/streaming.vue')
  }, 
  { 
    path: '/playback2', 
    name: 'playback2', 
    component: () => import('../views/playback.vue')
  },
  { 
    path: '/test_play', 
    name: 'test_play', 
    component: () => import('../views/test_play.vue')
  },
    // view Constellation
  { 
    path: '/zones', 
    name: 'zones', 
    component: () => import('../views/add_zone.vue')
  },
  { 
    path: '/settings_zones', 
    name: 'settings_zones', 
    component: () => import('../components/zones/settings_zones.vue')
  }, 
  { 
    path: '/smart_event', 
    name: 'smart_event', 
    component: () => import('../views/add_alarms.vue')
  }, 
  {
    path : '/reports_alarms',
    name : 'reports_alarms',
    component : () => import('../components/reports/single_reports.vue'),
  },
  { 
    path: '/settings_alarm', 
    name: 'settings_alarm', 
    component: () => import('../components/alarms/settings_alarm.vue')
  }, 
  { 
    path: '/reports_event', 
    name: 'reports_event', 
    component: () => import('../components/alarms/reports.vue')
  }, 
  { 
    path: '/categories', 
    name: 'categories', 
    component: () => import('../components/alarms/categories.vue') 
  },
  { 
    path: '/access_rules', 
    name: 'access_rules', 
    component: () => import('../components/alarms/access_rules.vue') 
  },
  // Views LPR
  { 
    path: '/dashboard_lpr', 
    name: 'dashboard_lpr', 
    component: () => import('../views/lpr.vue') 
  }, 
  { 
    path: '/reports_lpr', 
    name: 'reports_lpr', 
    component: () => import('../components/reports/single_reports.vue') 
  },

  // Views Gun
  { 
    path: '/gun', 
    name: 'gun', 
    component: () => import('../views/gun.vue') 
  },
  { 
    path: '/sz_contacts', 
    name: 'sz_contacts', 
    component: () => import('../components/gun/safe_zone_contacts.vue') 
  },
  {
    path: '/mapview',
    name: 'mapview',
    component: () => import('../components/mapview.vue') 
  },
  {
    path: '/lists',
    name: 'lists',
    component: () => import('../views/add_list.vue') 
  },
  {
    path: '/new_list',
    name: 'new_list',
    component: () => import('../components/lists/listing_setting.vue') 
  },
  {
    path: '/listing_setting',
    name: 'listing_setting',
    component: () => import('../components/lists/listing_setting.vue') 
  },
  {
    path: '/list_lpr',
    name: 'list_lpr',
    component: () => import('../components/lists/listing_details.vue') 
  },

  {
    path: '/playback',
    name: 'playback',
    component: () => import('../views/playback2.vue') 
  },
  {
    path : '/reports',
    name : 'reports',
    component : () => import(/* webpackChunkName: "singlReports" */'../components/reports/single_reports.vue'),
  },
  {
    path : '/managers_parking',
    name : 'managers_parking',
    component : () => import('../views/managers_parking.vue'),
  },
  {
    path : '/reports_parking',
    name : 'reports_parking',
    component : () => import('../components/reports/single_reports.vue'),
  },
  {
    path: '/list_parking',
    name: 'list_parking',
    component: () => import('../components/lists/listing_details.vue') 
  },
  // workspace ag
  {
    path : '/workspaces',
    name : 'workspaces',
    component : () => import('../views/workspaces_ag.vue'),
  },
  {
    path : '/contacts',
    name : 'contacts',
    component : () => import('../views/add_contacts.vue'),
  },
  {
    path : '/new_contact',
    name : 'new_contact',
    component : () => import('../components/contacts/contact.vue'),
  },
  {
    path : '/settings_contact',
    name : 'settings_contact',
    component : () => import('../components/contacts/contact.vue'),
  },
  {
    path : '/profiles',
    name : 'profiles',
    component : () => import('../views/add_profiles.vue'),
  },
  {
    path : '/profile_settings',
    name : 'profile_settings',
    component : () => import('../components/profiles/profiles.vue'),
  },
  {
    path : '/reports_avc',
    name : 'reports_avc',
    component : () => import('../components/reports/single_reports.vue'),
  }, 
  {
    path : '/evidence_info/:type/:id',
    name : 'evidence_info',
    component : () => import('../views/evidence_info.vue'),
  }, 

  {
    path: '/alarm-stats/:id',
    name: 'alarm_stats',
    props: true,
    component: () => import(/* webpackChunkName: "alarm-stats" */ '../components/alarms/stats/AlarmStatsDashboard.vue')
  },

  // page not found
  {
    path : '*',
    name : '*',
    component : () => import('../components/info/page_not_found.vue'),
  },
  {
    path : '/not_allow_view',
    name : 'not_allow_view',
    component : () => import('../components/info/page_not_found.vue'),
  },
  {
    path : '/video_test',
    name : 'video_test',
    component : () => import('../components/tester/video_test.vue'),
  },
  /*{
    path : '/mapview_test',
    name : 'mapview_test',
    component : () => import('../components/mapview_test.vue'),
  },*/
]

// console.log("base url ", process.env.BASE_URL, api.base)
const router = new VueRouter({
  mode: 'history',
  base: api.base || process.env.BASE_URL,
  routes
})

// Permissions
let modules     = [],
    permissions = [];    
/*if (localStorage.getItem('General_parameters')) {
  const local   = JSON.parse(localStorage.getItem('General_parameters'));
  modules       = local.modules;

  // create list modules permissions
  modules.forEach(function(arr_per, idx_per){
    if (arr_per.enable && arr_per.permission_user) {
      permissions.push(arr_per.module);
      if (arr_per.assosiated_routes &&  arr_per.assosiated_routes.length > 0) {
        permissions = permissions.concat(arr_per.assosiated_routes);
      }
      if (arr_per.sub_modules && arr_per.sub_modules.length > 0) {
        
        arr_per.sub_modules.forEach( function (arr_sub, idx_per) {
          if (arr_sub.sub_module) {
            permissions.push(arr_sub.sub_module);
          }
        })
      }

    }
  })
  permissions.push("parameters");
  console.log(permissions, 'ROUTES Permissions')
}*/

//Handle Unauthorirized Acces

router.beforeEach((to, from, next) => {
  const publicPages   = ['/', '/security_psw', '/recover_psw', "*", "/not_allow_view", "/evidence_info", "/test"];
  const authRequired  = !publicPages.includes(to.path);
  const loggedIn      = localStorage.getItem('user');
  const role          = loggedIn ? JSON.parse(loggedIn).user.roleId : null; 
  // console.log("****************** to ", to)
  // trying to access a restricted page + not logged in
  // redirect to login page
  
  // console.log("to", to, " from ", from, " next", next)
  if (authRequired && !loggedIn) {
    next('/');
  }else{
      // check  pathname exists
    /*if (loggedIn){        
      
      if (routes.some( find => find['name'] === to.name)) {
          if (permissions && permissions.length > 0 && permissions.includes(to.name)) {          
            
            if (role !== 1  && to.name == 'parameters') {
              next('/dashboard');
            }
            next();     
          }else{
            next('/dashboard');
          }
      }else{
        next('/dashboard');
      }
    }else{
    }*/

      next();
  }
});

export default router
